import type { QueryClient } from '@tanstack/react-query';

export enum QueryKeys {
  getBillingProfile = 'getBillingProfile',
  getBillingPlans = 'getBillingPlans',
  getInvoices = 'getInvoices',
  getBillingUsage = 'getBillingUsage',
  getCreditLedger = 'getCreditLedger',
  getSubscriptions = 'getSubscriptions',
  getSubscriptionDetail = 'getSubscriptionDetail',
}

/**
 * Every query a subscription write can move. A cancel changes the plan's end date as well as its
 * status, and those arrive from different endpoints — refetching only the one the mutation calls
 * leaves the page half updated.
 */
export const BILLING_QUERY_KEYS = [
  QueryKeys.getBillingProfile,
  QueryKeys.getSubscriptions,
  QueryKeys.getSubscriptionDetail,
  QueryKeys.getCreditLedger,
];

export const invalidateBillingQueries = (queryClient: QueryClient) =>
  Promise.all(BILLING_QUERY_KEYS.map((key) => queryClient.invalidateQueries({ queryKey: [key] })));
